import api, { transformRequest, transformCursorResponse } from "services/api";

const mergeDebtorsAPI = api
  .enhanceEndpoints({
    addTagTypes: ["MergeDebtors"],
  })
  .injectEndpoints({
    endpoints: (build) => ({
      fetchEligibleDebtorsForGroup: build.query({
        query: (payload) => ({
          url: `/api/v1/core/merge-eligible-debtors/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        serializeQueryArgs: ({ queryArgs }) => {
          // Create a stable query key by sorting and stringifying the arguments
          const { status, virtualPage, prevToken, nextToken, ...rest } = queryArgs;
          const sortedArgs = Object.keys(rest)
            .sort()
            .reduce((result, key) => {
              result[key] = rest[key];
              return result;
            }, {});

          // Create a more explicit query key that includes all parameters including pagination
          const queryKey = JSON.stringify({
            status,
            virtualPage,
            prevToken,
            nextToken,
            ...sortedArgs,
          });
          return queryKey;
        },
        transformResponse: (response) => transformCursorResponse(response),
        // Disable caching to force fresh network requests
        keepUnusedDataFor: 0,
        providesTags: (results) => {
          const items = Array.isArray(results) ? results : results?.results || [];
          return items.length > 0
            ? [
                ...items.map(({ id }) => ({ type: "MergeDebtors", id })),
                { type: "MergeDebtors", id: "LIST" },
              ]
            : [{ type: "MergeDebtors", id: "LIST" }];
        },
      }),
      deleteEligibleDebtorsForGroup: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/merge-eligible-debtors/${payload.mergeEligibleDebtorsId}/delete/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: (results, error, arg) => [
          { type: "MergeDebtors", id: "LIST" },
          { type: "MergeDebtors", id: arg.mergeEligibleDebtorsId },
        ],
      }),
      mergeEligibleDebtors: build.mutation({
        query: (payload) => ({
          url: `/api/v1/core/merge-eligible-debtors/${payload.mergeEligibleDebtorsId}/merge/`,
          method: "POST",
          body: transformRequest(payload),
        }),
        invalidatesTags: (result, error, arg) => [
          { type: "MergeDebtors", id: "LIST" },
          { type: "MergeDebtors", id: arg.mergeEligibleDebtorsId },
        ],
      }),
    }),
  });

export const {
  useFetchEligibleDebtorsForGroupQuery,
  useDeleteEligibleDebtorsForGroupMutation,
  useMergeEligibleDebtorsMutation,
} = mergeDebtorsAPI;
